import axios from 'axios'
import authHeader from './auth-header'

class RenegociacoesService {
  getEfetivadas(params = {}) {
    return axios.get(process.env.VUE_APP_API_URL + 'renegociacao/efetivadas/listagem', {
      params,
      headers: authHeader()
    })
  }

  downloadTermo(idRenegociacaoEfetivada) {
    return axios.get(
      process.env.VUE_APP_API_URL + `renegociacao/efetivadas/${idRenegociacaoEfetivada}/termo`,
      {
        headers: authHeader(),
        responseType: 'blob'
      }
    )
  }
}

export default new RenegociacoesService()
